import { TTrainingFilter } from "~/pages/StaffTraining/ui/StaffTrainingFilter/model/config";
import { FILTER_BY } from "~/shared/hooks/useStaffFilterData/useStaffFilterData";
import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";
import { EmployeeEducationStatisticsCoursesReportGetterParams } from "~/entity/Employee/model/schema";
import {
  getDealerGroupFilter,
  getFiltersVal,
  resolveGroupFilter,
} from "~/shared/ui/FIlterPresets/DefaultFilterView/model/lib";
import { TTrainingCoursesDetailsFilter } from "~/pages/StaffTrainingDetails/model/config";

export const toServer = (
  filter: TTrainingCoursesDetailsFilter
): EmployeeEducationStatisticsCoursesReportGetterParams => {
  const itemsForService = getFiltersVal(filter.filterItems, "string");
  return {
    actualOn: dateFormat(filter.period, { type: "date-special" }),
    positionIds: getFiltersVal(filter.filterExpectations, "number"),
    dealerGroup: {
      ids: [],
      cities: [],
      FOs: [],
      countries: [],
      subjects: [],
      ...getDealerGroupFilter(
        filter.filterBy?.value as keyof FILTER_BY,
        itemsForService
      ),
    },
    courseIds: getFiltersVal(filter.filterCourse, "number"),
    group: resolveGroupFilter(filter.filterBy.value as keyof FILTER_BY),
  };
};
